/* Tysk katalog for locale-closing-focused-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('de', {
  'clo.focus.finalConfirmation': 'Ich habe die Grundlage, Eigenkapitalereignisse, Ereignisse nach dem Stichtag und die Unternehmensfortführung geprüft. Alle notwendigen Buchungen und Einschätzungen sind geklärt. Ich genehmige den Abschluss des Jahres. Genehmigende Person und Zeitpunkt werden im Verlauf gespeichert.',
  'clo.focus.approve': 'Freigeben',
  'clo.focus.startYear': 'Startjahr der Buchhaltung',
  'clo.focus.bankSetupMissing': 'Erfasse Startdatum und dokumentierten Anfangssaldo in der Kontoeinrichtung unten. Gib 0 ein, wenn der Saldo null war.',
  'clo.focus.bankStatements': 'Kontoauszüge fehlen für die Zeiträume',
  'clo.focus.bankUnsettled': 'Abzustimmende Zeiträume',
  'clo.focus.bankDifferences': 'Saldoabweichungen müssen im Bankabgleich geklärt werden.',
  'clo.focus.bankUnconfigured': 'Lege Bankkonten mit dem richtigen Sachkonto für diese gebuchten Salden an',
  'clo.focus.reconcile': 'Abgleich abschließen',
  'clo.focus.restore': 'Größe wiederherstellen',
  'clo.focus.fullscreen': 'Vollbild',
  'clo.focus.notCalculated': 'Nicht berechnet',
  'clo.focus.taxScope': 'Steuerregime klären',
  'clo.focus.rateHelp': 'Die ordentliche norwegische Körperschaftsteuer beträgt seit 2019 22 %. Bestätige das Steuerregime, bevor die Berechnung freigegeben werden kann. Finanzsteuer und Sonderregime erfordern eine eigene Bewertung.',
  'clo.focus.industry': 'Steuerregime',
  'clo.focus.ordinary': 'Ordentliches Steuerregime',
  'clo.focus.special': 'Sonderregime – erfordert Bewertung',
  'clo.focus.finance': 'Finanzsteuerpflichtig',
  'clo.focus.priorLoss': 'Vortragsfähiger Verlust aus Vorjahren (auch 0 bestätigen)',
  'clo.focus.updateCalculation': 'Speichern und berechnen',
  'clo.focus.taxCalculation': 'So wird die Steuer berechnet',
  'clo.focus.resultBeforeTax': 'Ergebnis vor Steuern',
  'clo.focus.permanent': '+ Permanente Differenzen (netto)',
  'clo.focus.temporaryChange': '− Veränderung temporärer Differenzen',
  'clo.focus.lossApplied': '− Genutzter Verlustvortrag',
  'clo.focus.taxable': '= Steuerbemessungsgrundlage',
  'clo.focus.rate': 'Steuersatz',
  'clo.focus.resolveRate': 'Steuerregime oben klären',
  'clo.focus.payable': '= Zu zahlende Steuer',
  'clo.focus.lossRemaining': 'Verlustvortrag',
  'clo.focus.deferredTax': 'Latente Steuer / Steueranspruch',
  'clo.focus.temporary': 'Temporäre Differenzen',
  'clo.focus.unrecognized': 'Nicht bilanzierter Steueranspruch (Grundlage)',
  'clo.focus.deferredBasis': 'Grundlage für latente Steuer',
  'clo.focus.deferredAmount': 'Latente Steuer / Steueranspruch',
  'clo.focus.postingApproval': 'Berechnung und Abschlussbuchung freigeben',
  'clo.focus.postingHelp': 'Mit der Freigabe bestätigst du, dass du Steuerbemessungsgrundlage, Differenzen und Verlustvortrag geprüft hast. Zu zahlende Steuer und eine etwaige Veränderung der latenten Steuer werden beim Abschluss des Geschäftsjahres gebucht. Bereits gebuchte Beträge werden von der Abschlussbuchung berücksichtigt.',
  'clo.focus.postingAccounts': 'Berechnete zu zahlende Steuer: Soll 8300 / Haben 2500',
  'clo.focus.reviewRequired': 'Steuerregime oder besondere steuerliche Umstände müssen vor der Freigabe geklärt werden.',
  'clo.focus.unsaved': 'Speichere und berechne nach Änderungen, bevor du freigibst.',
  'clo.focus.editDifferences': 'Differenzen und Aufstellungen bearbeiten',
  'clo.checklist.custom.mappedDetail': 'Keine Konten ohne Zuordnung zum Standardkontenplan von Plumme. Importierte Konten werden geprüft, sobald sie im Kontenplan enthalten sind. Dies ist keine Prüfung der gesamten skattemelding-Zuordnung.',
  'clo.priorYear.closedDetail': 'Das Geschäftsjahr {{year}} ist abgeschlossen.',
  'clo.priorYear.noActivity': 'Für {{year}} sind in Plumme keine Buchhaltungszahlen erfasst. Das Startjahr allein entscheidet nicht, ob das Vorjahr abgeschlossen werden muss.',
});
